 <!-- HEADER -->
<prgov-spinner [loading]="!this.isSaving()" [overlayOpacity]="false" [bgLight]="true"></prgov-spinner>

<div class="d-flex justify-content-between m-3" style="height: 50px;">
    <button *ngIf="!paymentCompleted"
            class="ml-auto"
            color="primary"
            mat-stroked-button
            [disabled]="this.isSaving()"
            (click)="close()">
      {{'payment.close' | translate}}
    </button>
</div>
<!-- HEADER -->

<!-- CONTENT -->
<div *ngIf="!this.isSaving()">
  <ng-container>
    <div class="container-lg" id="container" [ngClass]="{'d-none': paymentCompleted}">
      <div class="row" style="justify-content: center;">
        <div class="col col-sm-12 col-lg-12">
          <!-- TITLES -->
          <h2>{{ 'payment.paymentPlanTitle' | translate }}</h2>
          <h2 [innerHTML]="transactionService.itemToEdit.ProcessName | ml:multiLanguageService.retrigger"></h2>
          <!-- TITLES -->

          <!-- ALERTS -->
          <prgov-alerts>
            <span>{{ planInfoText }}</span>
          </prgov-alerts>
          <prgov-alerts>
            <span>{{ convenienceFeeInfoText }}</span>
          </prgov-alerts>
          <!-- ALERTS -->

          <!-- TABLE -->
          <div class="table-container m-b-10">
            <table class="table mb-0">
              <tbody>
                <tr *ngFor="let item of transactionInvoice">
                  <td>
                    <ng-container >
                      <div [ngClass]="{'pay-title': item.id == 1 }">
                        {{ item.name }}
                      </div>
                    </ng-container>
                  </td>
                  <td class="text-right">
                    <ng-container>
                      <div [ngClass]="{'totals': item.id == 1 }">
                        {{ item.value }}
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- TABLE -->

          <!-- BUTTON CONFIRM-CANCEL -->
          <div class="row d-flex align-items-center mt-2">
            <div class="col-12 d-flex justify-content-end">
              <button mat-flat-button
                      color="primary"
                      (click)="this.cofirmButtonDisabled = !this.cofirmButtonDisabled">
                <div *ngIf="cofirmButtonDisabled" class="d-flex align-items-center">
                  <mat-icon class="mr-1">check</mat-icon>
                  <span>
                    {{ 'payment.confirmBtn' | translate }}
                  </span>
                </div>
                <span *ngIf="!cofirmButtonDisabled" class="d-flex align-items-center">
                  <mat-icon class="mr-1">close</mat-icon>
                  {{ 'payment.cancelBtn' | translate }}
                </span>
              </button>
            </div>
            <!-- BUTTON CONFIRM-CANCEL -->

            <div class="row w-100"
                 style="justify-content: center; margin-top: 20px;"
                 *ngIf="!cofirmButtonDisabled">
              <div class="col-lg-12">
                <form [formGroup]="form">
                  <!-- ADRESS INFO -->
                  <h3 class="border-bottom">{{'payment.address' | translate}}</h3>
                  <app-street-postal-address-form formControlName="PaymentAddress"
                                                  [showHeaders]="false"
                                                  [managePostal]="false">
                  </app-street-postal-address-form>
                  <!-- ADRESS INFO -->

                  <!-- PAYMENT INFORMATION -->
                  <h3 class="border-bottom mt-2">{{'payment.paymentInformation' | translate}}</h3>
                  <div class="card-container d-none">
                  </div>
                  <div class="form-group pt-3">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'payment.nameOnCard' | translate}} *</mat-label>
                      <input matInput
                             type="text"
                             formControlName="NameOnCard" />
                    </mat-form-field>
                  </div>
                  <div class="form-group">
                    <div class="mb-3">
                      <app-credit-card-selector></app-credit-card-selector>
                    </div>
                    <mat-form-field appearance="outline">
                      <mat-label>{{'payment.cardNumber' | translate}} *</mat-label>
                      <input matInput type="tel"
                             name="number"
                             formControlName="CardNumber"
                             (input)="formatValue($event)"/>
                    </mat-form-field>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>{{'payment.expiry' | translate}} (MM/YYYY) *</mat-label>
                          <input matInput type="text"
                                 name="expiry"
                                 mask="00 / 0000"
                                 formControlName="Expiry"
                                 [dropSpecialCharacters]="false" />
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>CVC *</mat-label>
                          <input matInput
                                 type="text"
                                 name="cvc"
                                 formControlName="CVC"
                                 maxlength="4"
                                 minlength="3"/>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="justify-content: center;">
                    <div class="col col-lg-12">
                      <div class="d-flex">
                        <button mat-button
                                color="primary"
                                (click)="tryPay()">
                          <ng-container>
                            {{'payment.paySubmit' | translate}}
                            <mat-icon>send</mat-icon>
                          </ng-container>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="mb-5"></div>
                  <!-- PAYMENT INFORMATION -->

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="payment-success d-flex align-items-center justify-content-center flex-column"
       *ngIf="paymentCompleted">
    <div class="icon">
      <i class="material-icons left">check</i>
    </div>
    <div class="amount"> {{ installmentNumber }} x {{this.currentInstallment | currency}}</div>
    <div class="message">{{'payment.complete' | translate}}</div>
    <div class="message mt-2" style="font-size:medium">{{'payment.verificationCode' | translate}}:</div>
    <div class="message" style="font-size:medium"> {{ authNumber }}</div>
    <div class="row mt-2">
      <div class="col col-sm-12">
        <button class="pull-left mr-1 btn-primary-mat" (click)="viewInvoice()">
          {{'payment.viewReceipt' | translate}}
        </button>
        <button class="pull-left mr-1 btn-primary-outlined-mat" [disabled]="this.isSaving()" (click)="close()">
          {{'payment.close' | translate}}
        </button>
      </div>
    </div>
  </div>
  <ng-template #terms>
  </ng-template>
</div>

<!-- CONTENT -->

